import { render, staticRenderFns } from "./InstallmentsEdit.vue?vue&type=template&id=15b4870b&scoped=true&"
import script from "./InstallmentsEdit.vue?vue&type=script&lang=js&"
export * from "./InstallmentsEdit.vue?vue&type=script&lang=js&"
import style0 from "./InstallmentsEdit.vue?vue&type=style&index=0&id=15b4870b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b4870b",
  null
  
)

export default component.exports